var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"voucher-assignment-failed-message"},[_vm._v(" "+_vm._s(_vm.$t("header:vouchers.assignmentFailed"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }